module.exports = __webpack_public_path__ + "6e20d1a6ff2645ec55874f4519495caa.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Avenir-Light.woff2?v=8.0d5e4
// module id = 929
// module chunks = 24